import {Directive, EventEmitter, HostBinding, HostListener, Input, Output} from '@angular/core';

@Directive({
  selector: '[copartDragdrop]'
})
export class DragdropDirective {

  @Input() private allowedFileExtensions: Array<string> = [];

  @Output() private onFileChangeEmitter: EventEmitter<File[]> = new EventEmitter();

  @Output() private fileInvalidEmitter: EventEmitter<string> = new EventEmitter<string>();

  constructor() {}

  @HostBinding('style.background') private background = '#eee';

  @HostListener('dragover', ['$event']) public onDragOver(evnt) {
    evnt.preventDefault();
    evnt.stopPropagation();
    this.background = '#999';
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#eee';
  }

  @HostListener('drop', ['$event']) public onDrop(evnt) {
      evnt.preventDefault();
      evnt.stopPropagation();
      this.background = '#eee';

      const files = evnt.dataTransfer.files;
      const valid_files: Array<File> = [];
      const invalid_files: Array<File> = [];

      if (files.length > 0) {
          for (const file of files) {
              const file_extension = file.name.split('.')[file.name.split('.').length - 1].toLowerCase();

              if (this.allowedFileExtensions.lastIndexOf(file_extension) !== -1) {
                  valid_files.push(file);
              } else {
                  invalid_files.push(file);
                  this.fileInvalidEmitter.emit(file_extension);
              }
          }

          this.onFileChangeEmitter.emit(valid_files);
      }
  }

}
